import React from 'react';

const DefaultBlankBoardHelpContent = () => (
  <div style={{ textAlign: 'center' }}>
    Stuck? Want to know how to add your first meals?
    <br />
    <br />
    <a
      style={{ color: 'var(--app-primary-font-color)' }}
      href="https://help.mealiq.io/recipes/adding-recipes"
      target="_blank"
      rel="noreferrer">
      Yes please! I need some help
    </a>
  </div>
);

export default DefaultBlankBoardHelpContent;
